export default __webpack_public_path__ + "static/media/bg3.771e2eee.jpg";